import type { VoidFunctionComponent } from 'react';

import Locator from '../../../../../../shared/Locator';
import Button from '../../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../../generic/Button/button-constants';
import { ManagePackageLabelsContent } from '../../../../modals/ModalManagePackageLabels/ManagePackageLabelsContent';
import { Tab } from '../../../../modals/ModalManagePackageLabels/types';
import { usePackageLabelState } from '../../../../modals/ModalManagePackageLabels/usePackageLabelState';

import styles from '../DependencyDrawer.module.less';

type Props = {
  dependencyLocator: string;
  dependencyTitle: string;
  parentRevisionLocator: string;
};

export const DependencyLabels: VoidFunctionComponent<Props> = ({
  dependencyLocator,
  dependencyTitle,
  parentRevisionLocator,
}) => {
  const state = usePackageLabelState(
    Locator.parsePackageString(dependencyLocator),
    Locator.parsePackageString(parentRevisionLocator),
  );

  const isAnyTabDirty = state.getIsAnyTabDirty(parentRevisionLocator);

  const onSave = () => {
    switch (state.tabs.activeTab) {
      case Tab.Global:
        return state.onSaveGlobal();
      case Tab.Project:
        return state.onSaveProject(Locator.parsePackageString(parentRevisionLocator));
      case Tab.Revision:
        return state.onSaveRevision(parentRevisionLocator);
      default:
        return () => {};
    }
  };

  return (
    <>
      <div className={styles.header}>Dependency Labels</div>
      <ManagePackageLabelsContent
        context={{ revision: dependencyLocator, title: dependencyTitle }}
        state={state}
        parentRevisionLocator={parentRevisionLocator}
        isProjectEnabled
        isRevisionEnabled
        isGlobalEnabled
        showPackageTitle={false}
      />
      <hr />
      <div className={styles.footer}>
        <Button
          type={BUTTON_TYPE.PRIMARY}
          size={BUTTON_SIZE.LARGE}
          onClick={onSave}
          isDisabled={!isAnyTabDirty}
        >
          Save
        </Button>
      </div>
    </>
  );
};
